import React, { useEffect, useState }  from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { Close, Search } from '@mui/icons-material';
import { Grid, Stack, Typography } from '@mui/material';
import { showModalEditFiltersImgState, showModalEditFiltersState } from '../../../store/reservation/reservationState';
import ButtonCustom from '../../../shared/components/buttons/ButtonCustom';
import ModalTitleCustom from '../../../shared/components/modals/ModalTitle';
import FormSearch from 'src/SearchHours/FormSearch';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import AlertCustom from 'src/shared/components/alerts/AlertCustom';
import { yellow } from '@mui/material/colors';
import { historyRouteState } from 'src/store/global/historyState';
import { dayDefaultAvailableState } from '../calendars/state/atoms';
import { dayAvailableDefaultFetchState, daysAvailableFetchState, filterSearchSelectedState, hoursAvailableFetchState, hoursAvailableState, isChangeFormSearchState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from 'src/SearchHours/state/atoms';
import ManageStorage from 'src/shared/global/manageStorage';
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import FormSearchProcedimiento from 'src/SearchHours/FormSearchProcedimiento';
import FormSearchImagenologia from 'src/SearchHours/FormSearchImagenologia';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function ModalEditFiltersImg() {
    const isChangeFormSearch = useRecoilValue(isChangeFormSearchState)
    const [showModalEditFiltersImg, setShowModalEditFiltersImg] = useRecoilState(showModalEditFiltersImgState);
    const [loading, setLoading] = useState(false)
    const {
      isEmptyFiltersImagenologia,
      loadHoursImagenologiaAvailable,
      loadDaysAvailableImagenologiaAndDefault
    } = useSearchHours();
    const historyRoute = useRecoilValue(historyRouteState);
    const resetDayDefaultAvailable = useResetRecoilState(dayDefaultAvailableState);
    //const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
    const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
    const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
    const refreshHours = useRecoilRefresher_UNSTABLE(hoursAvailableFetchState);
    const refreshDayAvailableDefault = useRecoilRefresher_UNSTABLE(dayAvailableDefaultFetchState);
    const refreshDaysAvailable = useRecoilRefresher_UNSTABLE(daysAvailableFetchState);
    const resetProfessionalsMatchCovenant = useResetRecoilState(professionalsMatchCovenantState);
    const resetProfessionalsNoMatchCovenant = useResetRecoilState(professionalsNoMatchCovenantState);
    const resetHoursAvailable = useResetRecoilState(hoursAvailableState);


    const handleClose = (ev, reason) => {
        if (reason && reason === "backdropClick") return;

        if (historyRoute.location.pathname.includes('/resultado-busqueda-imagenologia')) return;
        setShowModalEditFiltersImg(false);
    }

    useEffect(() => {
        return () => {
            setShowModalEditFiltersImg(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleEditFilters = () => {
        setLoading(true);
        eventGA();
        setTimeout(async () => {
            resetProfessionalsMatchCovenant();
            resetProfessionalsNoMatchCovenant();
            resetHoursAvailable();
            try {
                if (!ManageStorage.getValueFromStorage("currentUrl").includes("/resultado-busqueda-imagenologia")) {
                    resetDayDefaultAvailable();
                    refreshHours();
                    historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`);
                } else {
                    if (!dayDefaultAvailable) {
                        resetDayDefaultAvailable();
                        refreshDayAvailableDefault();
                        refreshDaysAvailable();
                        await loadDaysAvailableImagenologiaAndDefault()
                    }
                    await loadHoursImagenologiaAvailable()
                }
            } finally {
                setShowModalEditFiltersImg(false)
                setLoading(false)
            }

        }, 0)
    };

    const eventGA = () => {
        console.log("Evento Google Analytics -> Buscar Modal");
        let especialidad = filterSearchSelected.specialitySelected.value;
        especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
        let profesional = filterSearchSelected.professionalSelected.value;
        profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
        let prevision = filterSearchSelected.covenantSelected.value;
        prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
        console.log(`${especialidad} ${profesional} ${prevision}`);
        ReactGA.event({
            category: 'Buscar',
            action: `${especialidad} ${profesional} ${prevision}`
          });
    }

    return (
        <div>
            <BootstrapDialog
                disableEscapeKeyDown
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={showModalEditFiltersImg}
            >
                <ModalTitleCustom id="customized-dialog-title">
                    Reserva de hora
                </ModalTitleCustom>
                <DialogContent style={{ paddingTop: 16 }}>
                    <Typography variant="h5" mb={3}>
                        Busque imagenología
                    </Typography>
                    <FormSearchImagenologia></FormSearchImagenologia>

                    <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"} mt={2}>
                        {
                            isEmptyFiltersImagenologia() ?
                                <AlertCustom
                                    variant="outlined"
                                    severity="warning"
                                    message="Debe seleccionar los filtros de búsqueda"
                                    style={{ marginBottom: 15, backgroundColor: yellow[100], width: '100%' }}
                                />
                                : null
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Stack
                        width={'100%'}
                        display={"flex"}
                        justifyContent={"flex-end"}
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 2 }}
                    >
                        <ButtonCustom
                            loading={loading}
                            disabled={isEmptyFiltersImagenologia()}
                            color="secondary"
                            autoFocus
                            onClick={handleEditFilters}
                            text="BUSCAR HORAS"
                            icon={<Search />}
                        />
                        <ButtonCustom
                            disabled={isChangeFormSearch}
                            color="default"
                            autoFocus
                            onClick={() => {
                                setShowModalEditFiltersImg(false)
                            }}
                            text="Cancelar"
                            icon={<Close />}
                        />
                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
